export default __webpack_public_path__ + "static/media/HeroImageInterCel.6f916181.png";